export default "__VITE_ASSET__SVgpCzL1__"